const visualStyles = [
  "areaChart",
  "barChart",
  "basicShape",
  "card",
  "clusteredBarChart",
  "clusteredColumnChart",
  "columnChart",
  "comboChart",
  "donutChart",
  "filledMap",
  "funnel",
  "gauge",
  "hundredPercentStackedBarChart",
  "hundredPercentStackedColumnChart",
  "image",
  "kpi",
  "lineChart",
  "lineClusteredColumnComboChart",
  "lineStackedColumnComboChart",
  "map",
  "multiRowCard",
  "pieChart",
  "pivotTable",
  "ribbonChart",
  "scatterChart",
  "shapeMap",
  "slicer",
  "stackedAreaChart",
  "tableEx",
  "treemap",
  "waterfallChart"
];
import countriesList from '../assets/countriesList';
const countriFormatedList = Object.entries(countriesList).map(([value, displayName]) => ({ value, displayName }))

const cardName = {
  axis: "Gauge axis",
  breakdown: "Breakdown",
  bubbles: "Bubbles",
  calloutValue: "Callout Value",
  card: "Card",
  cardTitle: "Card Title",
  categoryAxis: "X-Axis",
  categoryLabels: "Category labels",
  columnFormatting: "Field formatting",
  columnHeaders: "Column headers",
  dataLabels: "Data labels",
  fill: "Fill",
  fillPoint: "Fill point",
  forecast: "Forecast",
  general: "General",
  goals: "Goals",
  grid: "Grid",
  header: "Header",
  imageScaling: "Scaling",
  indicator: "Indicator",
  items: "Items",
  labels: "Data labels",
  legend: "Legend",
  lineStyles: "Shapes",
  mapControls: "Map controls",
  mapStyles: "Map styles",
  numericInputStyle: "Numeric inputs",
  percentBarLabel: "Conversion Rate Label",
  plotArea: "Plot Area",
  plotAreaShading: "Symmetry shading",
  ratioLine: "Ratio line",
  referenceLine: "Constant Line",
  ribbonChart: "Ribbons",
  rotation: "Rotation",
  rowHeaders: "Row headers",
  selection: "Selection Controls",
  sentimentColors: "Sentiment colors",
  shape: "Shape",
  slider: "Slider",
  status: "Color coding",
  subTotals: "Subtotals",
  target: "Target",
  total: "Grand total",
  trend: "Trend Line",
  trendline: "Trend axis",
  valueAxis: "Y-Axis",
  values: "Values",
  wordWrap: "Word wrap",
  xAxisReferenceLine: "X-Axis Constant Line",
  y1AxisReferenceLine: "Constant Line",
  zoom: "Zoom",
  defaultColors: 'Default Colors',
  dataPoint: 'Data Colors',
  line: 'Line',
  visualHeader: 'Visual Header',
  title: 'Title',
  border: 'Border',
  background: 'Background',
  "*": 'Font',
  y2Axis: ' Secondary Y axis ',
  name: 'Theme name',
  themeColors: 'Theme Colors',
  statusColors: 'Status colors',
  variousGradient: 'Gradient colors',
  advanced: 'Advanced',
  textClassesLabel: 'Label text',
  textClassesTitle: 'Title text',
  textClassesHeader: 'Header text',
  textClassesCallout: 'Callout text',
  visualTooltip: 'Visual Tooltip',
  visualHeaderTooltip: 'Header Tooltip',
  dropShadow: 'Drop Shadow',
  outspacePane: 'Filter Pane',
  filterCardApplied: 'Applied Card filter',
  filterCardAvailable: 'Available Card filter',
  outspacePane: 'Filter Pane',
  outspace: 'Outspace',
  analysis: 'Analysis',
  tree: 'Tree',
  dataBars: 'Data Bars',
  levelHeader: 'Visual Header',
  slices: 'Slices',
  colorByCategory: 'Color by category',
  stylePreset: 'Style Preset',
  data: 'Data',
  lockAspect: 'Lock Aspect',
  shapes: "Shapes",
  heatMap: "Heat Map",
  keyDrivers: "Analysis",
  keyInfluencersVisual: "Analysis visual colors",
  keyDriversDrillVisual: "Drill visual colors",
  shadow: "Shadow",
  glow: "Glow",
  mapTools: "Map Tools",
  layers: "layers",
  locationType: "Location Type",
  autoFilter: "Auto Filter",
  toolbar: "Toolbar",
  inputBox: "Input Box",
  suggestions: "Suggestions",
  totals: "Totals",
  layers: "Layers",
};

const items = {
  general: {
    responsive: {
      type: ["bool"],
      displayName: ["(Preview) Responsive"],
      description: ["The visual will adapt to size changes"]
    }
  },
  legend: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    position: {
      type: ["enumeration"],
      displayName: ["Position"],
      description: ["Select the location for the legend"]
    },
    showTitle: {
      type: ["bool"],
      displayName: ["Title"],
      description: ["Display a title for legend symbols"]
    },
    labelColor: {
      type: ["fill"],
      displayName: ["Color"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    }
  },
  categoryAxis: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    axisScale: {
      type: ["enumeration"],
      displayName: ["Scale type"]
    },
    start: {
      type: ["numeric", "dateTime"],
      displayName: ["Start"],
      description: ["Enter a starting value (optional)"]
    },
    end: {
      type: ["numeric", "dateTime"],
      displayName: ["End"],
      description: ["Enter an ending value (optional)"]
    },
    axisType: {
      type: ["enumeration"],
      displayName: ["Type"]
    },
    showAxisTitle: {
      type: ["bool"],
      displayName: ["Title"],
      description: ["Title for the X-axis", "Title for the Y-axis"]
    },
    axisStyle: {
      type: ["enumeration"],
      displayName: ["Style"]
    },
    labelColor: {
      type: ["fill"],
      displayName: ["Color"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    labelDisplayUnits: {
      type: ["formatting"],
      displayName: ["Display units"],
      description: ["Select the units (millions, billions, etc.)"]
    },
    labelPrecision: {
      type: ["numeric"],
      displayName: ["Value decimal places"],
      description: [
        "Select the number of decimal places to display for the values"
      ]
    },
    concatenateLabels: {
      type: ["bool"],
      displayName: ["Concatenate labels"],
      description: [
        "Always concatenate levels of the hierarchy instead of drawing the hierarchy."
      ]
    },
    preferredCategoryWidth: {
      type: ["numeric"],
      displayName: ["Minimum category width"]
    },
    titleColor: {
      type: ["fill"],
      displayName: ["Title color"]
    },
    titleFontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    titleFontSize: {
      type: ["formatting"],
      displayName: ["Title text size"]
    },
    position: {
      type: ["enumeration"],
      displayName: ["Position"],
      description: ["Select left or right"]
    },
    color: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Select color for data labels"]
    },
    duration: {
      type: ["numeric"]
    }
  },
  valueAxis: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    position: {
      type: ["enumeration"],
      displayName: ["Position"],
      description: ["Select left or right"]
    },
    axisScale: {
      type: ["enumeration"],
      displayName: ["Scale type"]
    },
    start: {
      type: ["numeric", "dateTime"],
      displayName: ["Start"],
      description: ["Enter a starting value (optional)"]
    },
    end: {
      type: ["numeric", "dateTime"],
      displayName: ["End"],
      description: ["Enter an ending value (optional)"]
    },
    showAxisTitle: {
      type: ["bool"],
      displayName: ["Title"],
      description: ["Title for the Y-axis", "Title for the X-axis"]
    },
    axisStyle: {
      type: ["enumeration"],
      displayName: ["Style"]
    },
    labelColor: {
      type: ["fill"],
      displayName: ["Color"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    labelDisplayUnits: {
      type: ["formatting"],
      displayName: ["Display units"],
      description: ["Select the units (millions, billions, etc.)"]
    },
    labelPrecision: {
      type: ["numeric"],
      displayName: ["Value decimal places"],
      description: [
        "Select the number of decimal places to display for the values"
      ]
    },
    titleColor: {
      type: ["fill"],
      displayName: ["Title color"]
    },
    titleFontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    titleFontSize: {
      type: ["formatting"],
      displayName: ["Title text size"]
    },
    axisLabel: {
      type: ["none"],
      displayName: ["Y-Axis (Column)"]
    },
    secShow: {
      type: ["bool"],
      displayName: ["Show secondary"]
    },
    alignZeros: {
      type: ["bool"],
      displayName: ["Align zeros"],
      description: ["Align the zero tick marks for both value axes"]
    },
    secAxisLabel: {
      type: ["none"],
      displayName: ["Y-Axis (Line)"]
    },
    secPosition: {
      type: ["enumeration"],
      displayName: ["Position"],
      description: ["Select left or right"]
    },
    secAxisScale: {
      type: ["enumeration"],
      displayName: ["Scale type"]
    },
    secStart: {
      type: ["numeric"],
      displayName: ["Start"],
      description: ["Enter a starting value (optional)"]
    },
    secEnd: {
      type: ["numeric"],
      displayName: ["End"],
      description: ["Enter an ending value (optional)"]
    },
    secShowAxisTitle: {
      type: ["bool"],
      displayName: ["Title"],
      description: ["Title for the Y-axis"]
    },
    secAxisStyle: {
      type: ["enumeration"],
      displayName: ["Style"]
    },
    secLabelColor: {
      type: ["fill"],
      displayName: ["Color"]
    },
    secFontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    secFontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    secLabelDisplayUnits: {
      type: ["formatting"],
      displayName: ["Display units"],
      description: ["Select the units (millions, billions, etc.)"]
    },
    secLabelPrecision: {
      type: ["numeric"],
      displayName: ["Value decimal places"],
      description: [
        "Select the number of decimal places to display for the values"
      ]
    },
    secTitleColor: {
      type: ["fill"],
      displayName: ["Title color"]
    },
    secTitleFontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    secTitleFontSize: {
      type: ["formatting"],
      displayName: ["Title text size"]
    }
  },
  dataPoint: {
    defaultColor: {
      type: ["fill"],
      displayName: ["Default color", "Default Column Color"]
    },
    fill: {
      type: ["fill"],
      displayName: ["Fill"]
    },
    defaultCategoryColor: {
      type: ["fill"],
      displayName: ["Default color", "Default Column Color"]
    },
    showAllDataPoints: {
      type: ["bool"],
      displayName: ["Show all"]
    }
  },
  labels: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    showSeries: {
      type: ["bool"],
      displayName: ["Show"]
    },
    color: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Select color for data labels"]
    },
    labelDisplayUnits: {
      type: ["formatting"],
      displayName: ["Display units"],
      description: ["Select the units (millions, billions, etc.)"]
    },
    labelPrecision: {
      type: ["numeric"],
      displayName: ["Value decimal places"],
      description: [
        "Select the number of decimal places to display for the values"
      ]
    },
    showAll: {
      type: ["bool"],
      displayName: ["Customize series"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    labelDensity: {
      type: ["formatting"],
      displayName: ["Label density"]
    },
    labelOrientation: {
      type: ["enumeration"],
      displayName: ["Orientation"]
    },
    labelPosition: {
      type: ["enumeration"],
      displayName: ["Position"]
    },
    percentageLabelPrecision: {
      type: ["numeric"],
      displayName: ["% decimal places"],
      description: [
        "Select the number of decimal places to display for the percentages"
      ]
    },
    labelStyle: {
      type: ["enumeration"],
      displayName: ["Label style"]
    }
  },
  lineStyles: {
    strokeWidth: {
      type: ["numeric"],
      displayName: ["Stroke width"]
    },
    strokeLineJoin: {
      type: ["enumeration"],
      displayName: ["Join type"]
    },
    lineStyle: {
      type: ["enumeration"],
      displayName: ["Line style"]
    },
    showMarker: {
      type: ["bool"],
      displayName: ["Show marker"]
    },
    markerShape: {
      type: ["enumeration"],
      displayName: ["Marker shape"]
    },
    markerSize: {
      type: ["numeric"],
      displayName: ["Marker size"]
    },
    markerColor: {
      type: ["fill"],
      displayName: ["Marker color"]
    },
    showSeries: {
      type: ["bool"],
      displayName: ["Customize series", "Show"]
    },
    shadeArea: {
      type: ["bool"],
      displayName: ["Shade area"]
    }
  },
  plotArea: {
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for background color"]
    }
  },
  trend: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    displayName: {
      type: ["text"],
      displayName: ["Name"],
      description: ["Set trend line name"]
    },
    lineColor: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Set trend line color"]
    },
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for trend line color"]
    },
    style: {
      type: ["enumeration"],
      displayName: ["Style"],
      description: ["Set trend line style"]
    },
    combineSeries: {
      type: ["bool"],
      displayName: ["Combine Series"],
      description: ["Show one trend line per series or combine"]
    }
  },
  y1AxisReferenceLine: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    value: {
      type: ["numeric"],
      displayName: ["Value"],
      description: ["Set reference line numeric value"]
    },
    lineColor: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Set reference line color"]
    },
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for reference line color"]
    },
    style: {
      type: ["enumeration"],
      displayName: ["Line style"]
    },
    position: {
      type: ["enumeration"],
      displayName: ["Position"],
      description: ["Arrange relative to chart data points"]
    },
    dataLabelShow: {
      type: ["bool"],
      displayName: ["Data label"],
      description: ["Display a data label for the reference line"]
    },
    dataLabelColor: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Set the reference line data label color"]
    },
    dataLabelDecimalPoints: {
      type: ["numeric"],
      displayName: ["Decimal Places"]
    },
    dataLabelHorizontalPosition: {
      type: ["enumeration"],
      displayName: ["Horizontal Position"],
      description: [
        "Set the horizontal position for the reference line data label"
      ]
    },
    dataLabelVerticalPosition: {
      type: ["enumeration"],
      displayName: ["Vertical Position"],
      description: [
        "Set the vertical position for the reference line data label"
      ]
    },
    dataLabelDisplayUnits: {
      type: ["formatting"],
      displayName: ["Display units"],
      description: ["Select the units (millions, billions, etc.)"]
    }
  },
  referenceLine: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    displayName: {
      type: ["text"],
      displayName: ["Name"],
      description: ["Set reference line name"]
    },
    value: {
      type: ["numeric"],
      displayName: ["Value"],
      description: ["Set reference line numeric value"]
    },
    lineColor: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Set reference line color"]
    },
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for reference line color"]
    },
    style: {
      type: ["enumeration"],
      displayName: ["Line style"]
    },
    position: {
      type: ["enumeration"],
      displayName: ["Position"],
      description: ["Arrange relative to chart data points"]
    },
    dataLabelShow: {
      type: ["bool"],
      displayName: ["Data label"],
      description: ["Display a data label for the reference line"]
    },
    dataLabelColor: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Set the reference line data label color"]
    },
    dataLabelDecimalPoints: {
      type: ["numeric"],
      displayName: ["Decimal Places"]
    },
    dataLabelHorizontalPosition: {
      type: ["enumeration"],
      displayName: ["Horizontal Position"],
      description: [
        "Set the horizontal position for the reference line data label"
      ]
    },
    dataLabelVerticalPosition: {
      type: ["enumeration"],
      displayName: ["Vertical Position"],
      description: [
        "Set the vertical position for the reference line data label"
      ]
    },
    dataLabelDisplayUnits: {
      type: ["formatting"],
      displayName: ["Display units"],
      description: ["Select the units (millions, billions, etc.)"]
    }
  },
  line: {
    lineColor: {
      type: ["fill"],
      displayName: ["Line color"]
    },
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for background color"]
    },
    weight: {
      type: ["numeric"],
      displayName: ["Weight"]
    },
    roundEdge: {
      type: ["numeric"],
      displayName: ["Round edges"]
    }
  },
  fill: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    fillColor: {
      type: ["fill"],
      displayName: ["Fill color"]
    },
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for background color"]
    }
  },
  rotation: {
    angle: {
      type: ["numeric"],
      displayName: ["Rotation"]
    }
  },
  categoryLabels: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    color: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Select color for data labels"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    }
  },
  wordWrap: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    }
  },
  dataLabels: {
    color: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Select color for data labels"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    }
  },
  cardTitle: {
    color: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Select color for data labels"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    }
  },

  card: {
    outline: {
      type: ["enumeration"],
      displayName: ["Outline"]
    },
    outlineColor: {
      type: ["fill"],
      displayName: ["Outline color"],
      description: ["Color of the outline"]
    },
    outlineWeight: {
      type: ["numeric"],
      displayName: ["Outline weight"],
      description: ["Thickness of the outline in pixels"]
    },
    barShow: {
      type: ["bool"],
      displayName: ["Show bar"],
      description: ["Display a bar to the left side of the card as an accent"]
    },
    barColor: {
      type: ["fill"],
      displayName: ["Bar color"]
    },
    barWeight: {
      type: ["numeric"],
      displayName: ["Bar thickness"],
      description: ["Thickness of the bar in pixels"]
    },
    cardPadding: {
      type: ["numeric"],
      displayName: ["Padding"],
      description: ["Background"]
    },
    cardBackground: {
      type: ["fill"],
      displayName: ["Background"]
    }
  },
  percentBarLabel: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    color: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Select color for data labels"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    }
  },
  axis: {
    min: {
      type: ["numeric"],
      displayName: ["Min"]
    },
    max: {
      type: ["numeric"],
      displayName: ["Max"]
    },
    target: {
      type: ["numeric"],
      displayName: ["Target"]
    }
  },
  target: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    color: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Select color for data labels"]
    },
    labelDisplayUnits: {
      type: ["formatting"],
      displayName: ["Display units"],
      description: ["Select the units (millions, billions, etc.)"]
    },
    labelPrecision: {
      type: ["numeric"],
      displayName: ["Value decimal places"],
      description: [
        "Select the number of decimal places to display for the values"
      ]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    }
  },
  calloutValue: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    color: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Select color for data labels"]
    },
    labelDisplayUnits: {
      type: ["formatting"],
      displayName: ["Display units"],
      description: ["Select the units (millions, billions, etc.)"]
    },
    labelPrecision: {
      type: ["numeric"],
      displayName: ["Value decimal places"],
      description: [
        "Select the number of decimal places to display for the values"
      ]
    }
  },
  forecast: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    displayName: {
      type: ["text"],
      displayName: ["Name"],
      description: ["Set forecast name"]
    },
    confidenceBandStyle: {
      type: ["enumeration"],
      displayName: ["Confidence band style"],
      description: ["Set forecast confidence band style"]
    },
    lineColor: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Set forecast line color"]
    },
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for background color"]
    },
    style: {
      type: ["enumeration"],
      displayName: ["Line style"]
    },
    transform: {
      type: ["queryTransform"]
    }
  },
  bubbles: {
    bubbleSize: {
      type: ["formatting"],
      displayName: ["Size"]
    }
  },
  mapControls: {
    autoZoom: {
      type: ["bool"],
      displayName: ["Auto zoom"]
    },
    zoomLevel: {
      type: ["numeric"]
    },
    centerLatitude: {
      type: ["numeric"]
    },
    centerLongitude: {
      type: ["numeric"]
    }
  },
  mapStyles: {
    mapTheme: {
      type: ["enumeration"],
      displayName: ["Theme"]
    }
  },
  shape: {
    map: {
      type: ["geoJson"]
    },
    projectionEnum: {
      type: ["enumeration"],
      displayName: ["Projection"],
      description: ["Projection"]
    }
  },
  zoom: {
    autoZoom: {
      type: ["bool"],
      displayName: ["Auto zoom"],
      description: ["Zoom in on shapes with available data"]
    },
    selectionZoom: {
      type: ["bool"],
      displayName: ["Selection zoom"],
      description: ["Zoom in on selected shapes"]
    },
    manualZoom: {
      type: ["bool"],
      displayName: ["Manual zoom"],
      description: ["Allow user to zoom and pan"]
    }
  },
  xAxisReferenceLine: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    value: {
      type: ["numeric"],
      displayName: ["Value"],
      description: ["Set reference line numeric value"]
    },
    lineColor: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Set reference line color"]
    },
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for reference line color"]
    },
    style: {
      type: ["enumeration"],
      displayName: ["Line style"]
    },
    position: {
      type: ["enumeration"],
      displayName: ["Position"],
      description: ["Arrange relative to chart data points"]
    },
    dataLabelShow: {
      type: ["bool"],
      displayName: ["Data label"],
      description: ["Display a data label for the reference line"]
    },
    dataLabelColor: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Set the reference line data label color"]
    },
    dataLabelDecimalPoints: {
      type: ["numeric"],
      displayName: ["Decimal Places"]
    },
    dataLabelHorizontalPosition: {
      type: ["enumeration"],
      displayName: ["Horizontal Position"],
      description: [
        "Set the horizontal position for the reference line data label"
      ]
    },
    dataLabelVerticalPosition: {
      type: ["enumeration"],
      displayName: ["Vertical Position"],
      description: [
        "Set the vertical position for the reference line data label"
      ]
    },
    dataLabelDisplayUnits: {
      type: ["formatting"],
      displayName: ["Display units"],
      description: ["Select the units (millions, billions, etc.)"]
    }
  },
  fillPoint: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    }
  },
  colorByCategory: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    }
  },
  plotAreaShading: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    upperShadingColor: {
      type: ["fill"],
      displayName: ["Upper shading"],
      description: ["Shading color of the upper region"]
    },
    lowerShadingColor: {
      type: ["fill"],
      displayName: ["Lower shading"],
      description: ["Shading color of the lower region"]
    },
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for background color"]
    }
  },
  ratioLine: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    lineColor: {
      type: ["fill"],
      displayName: ["Color"],
      description: ["Set reference line color"]
    },
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for line color"]
    },
    style: {
      type: ["enumeration"],
      displayName: ["Line style"]
    }
  },
  grid: {
    outlineColor: {
      type: ["fill"],
      displayName: ["Outline color"],
      description: ["Color of the outline"]
    },
    outlineWeight: {
      type: ["numeric"],
      displayName: ["Outline weight"],
      description: ["Thickness of the outline in pixels"]
    },
    gridVertical: {
      type: ["bool"],
      displayName: ["Vert grid"],
      description: ["Show/Hide the vertical gridlines"]
    },
    gridVerticalColor: {
      type: ["fill"],
      displayName: ["Vert grid color"],
      description: ["Color for the vertical gridlines"]
    },
    gridVerticalWeight: {
      type: ["numeric"],
      displayName: ["Vert grid thickness"],
      description: ["Thickness of the vertical gridlines in pixels"]
    },
    gridHorizontal: {
      type: ["bool"],
      displayName: ["Horiz grid"],
      description: ["Show/Hide the horizontal gridlines"]
    },
    gridHorizontalColor: {
      type: ["fill"],
      displayName: ["Horiz grid color"],
      description: ["Color for the horizontal gridlines"]
    },
    gridHorizontalWeight: {
      type: ["numeric"],
      displayName: ["Horiz grid thickness"],
      description: ["Thickness of the horizontal gridlines in pixels"]
    },
    rowPadding: {
      type: ["numeric"],
      displayName: ["Row padding"],
      description: [
        "Padding in pixels applied to top and bottom of every row"
      ]
    },
    imageHeight: {
      type: ["numeric"],
      displayName: ["Image height"],
      description: ["The height of images in pixels"]
    },
    textSize: {
      type: ["numeric"],
      displayName: ["Text Size"]
    }
  },
  columnHeaders: {
    outline: {
      type: ["enumeration"],
      displayName: ["Outline"]
    },
    fontColor: {
      type: ["fill"],
      displayName: ["Font color"],
      description: ["Font color of the cells"]
    },
    backColor: {
      type: ["fill"],
      displayName: ["Background color"],
      description: ["Background color of the cells"]
    },
    wordWrap: {
      type: ["bool"],
      displayName: ["Word wrap"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    autoSizeColumnWidth: {
      type: ["bool"],
      displayName: ["Auto-size column width"]
    },
    urlIcon: {
      type: ["bool"],
      displayName: ["URL icon"],
      description: ["Show an icon instead of the full URL"]
    }
  },
  values: {
    outline: {
      type: ["enumeration"],
      displayName: ["Outline"]
    },
    backColor: {
      type: ["fill"],
      displayName: ["Color scales"]
    },
    fontColorPrimary: {
      type: ["fill"],
      displayName: ["Font color"],
      description: ["Font color of the odd rows"]
    },
    backColorPrimary: {
      type: ["fill"],
      displayName: ["Background color"],
      description: ["Background color of the odd rows"]
    },
    fontColorSecondary: {
      type: ["fill"],
      displayName: ["Alternate font color"],
      description: ["Font color of the even rows"]
    },
    backColorSecondary: {
      type: ["fill"],
      displayName: ["Alternate background color"],
      description: ["Background color of the even rows"]
    },
    urlIcon: {
      type: ["bool"],
      displayName: ["URL icon"],
      description: ["Show an icon instead of the full URL"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    wordWrap: {
      type: ["bool"],
      displayName: ["Word wrap"]
    },
    bandedRowHeaders: {
      type: ["bool"],
      displayName: ["Banded row style"],
      description: [
        "Apply banded row style to the last level of the row group headers, using the colors of the values."
      ]
    },
    valuesOnRow: {
      type: ["bool"],
      displayName: ["Show on rows"],
      description: ["Show values in row groups rather than columns"]
    }
  },
  total: {
    outline: {
      type: ["enumeration"],
      displayName: ["Outline"]
    },
    fontColor: {
      type: ["fill"],
      displayName: ["Font color"],
      description: ["Font color of the cells"]
    },
    backColor: {
      type: ["fill"],
      displayName: ["Background color"],
      description: ["Background color of the cells"]
    },
    applyToHeaders: {
      type: ["bool"],
      displayName: ["Apply to labels"]
    },
    totals: {
      type: ["bool"],
      displayName: ["Totals"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    }
  },
  columnFormatting: {
    fontColor: {
      type: ["fill"],
      displayName: ["Font color"],
      description: ["Font color of the cells"]
    },
    backColor: {
      type: ["fill"],
      displayName: ["Background color"],
      description: ["Background color of the cells"]
    },
    styleHeader: {
      type: ["bool"],
      displayName: ["Color header"]
    },
    styleValues: {
      type: ["bool"],
      displayName: ["Color values"]
    },
    styleTotal: {
      type: ["bool"],
      displayName: ["Color total"]
    },
    styleSubtotals: {
      type: ["bool"],
      displayName: ["Color subtotals"]
    }
  },
  rowHeaders: {
    outline: {
      type: ["enumeration"],
      displayName: ["Outline"]
    },
    fontColor: {
      type: ["fill"],
      displayName: ["Font color"],
      description: ["Font color of the cells"]
    },
    backColor: {
      type: ["fill"],
      displayName: ["Background color"],
      description: ["Background color of the cells"]
    },
    wordWrap: {
      type: ["bool"],
      displayName: ["Word wrap"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    stepped: {
      type: ["bool"],
      displayName: ["Stepped layout"],
      description: ["Render row headers with stepped layout"]
    },
    steppedLayoutIndentation: {
      type: ["numeric"],
      displayName: ["Stepped layout indentation"],
      description: ["Set the indentation, in pixels, applied to row headers"]
    },
    urlIcon: {
      type: ["bool"],
      displayName: ["URL icon"],
      description: ["Show an icon instead of the full URL"]
    }
  },
  subTotals: {
    outline: {
      type: ["enumeration"],
      displayName: ["Outline"]
    },
    fontColor: {
      type: ["fill"],
      displayName: ["Font color"],
      description: ["Font color of the cells"]
    },
    backColor: {
      type: ["fill"],
      displayName: ["Background color"],
      description: ["Background color of the cells"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    fontSize: {
      type: ["formatting"],
      displayName: ["Text Size"]
    },
    rowSubtotals: {
      type: ["bool"],
      displayName: ["Total row"]
    },
    columnSubtotals: {
      type: ["bool"],
      displayName: ["Total column"]
    },
    applyToHeaders: {
      type: ["bool"],
      displayName: ["Apply to labels"]
    }
  },
  selection: {
    selectAllCheckboxEnabled: {
      type: ["bool"],
      displayName: ["Select All"]
    },
    singleSelect: {
      type: ["bool"],
      displayName: ["Single Select"]
    }
  },
  header: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    fontColor: {
      type: ["fill"],
      displayName: ["Font color"],
      description: ["Font color of the cells"]
    },
    background: {
      type: ["fill"],
      displayName: ["Background"]
    },
    outline: {
      type: ["enumeration"],
      displayName: ["Outline"]
    },
    textSize: {
      type: ["numeric"],
      displayName: ["Text Size"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    }
  },
  items: {
    fontColor: {
      type: ["fill"],
      displayName: ["Font color"],
      description: ["Font color of the cells"]
    },
    background: {
      type: ["fill"],
      displayName: ["Background"]
    },
    outline: {
      type: ["enumeration"],
      displayName: ["Outline"]
    },
    textSize: {
      type: ["numeric"],
      displayName: ["Text Size"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    }
  },
  title: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    fontColor: {
      type: ["fill"],
      displayName: ["Font color"],
      description: ["Font color of the cells"]
    },
    background: {
      type: ["fill"],
      displayName: ["Background"]
    },
    outline: {
      type: ["enumeration"],
      displayName: ["Outline"]
    },
    textSize: {
      type: ["numeric"],
      displayName: ["Text Size"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    }
  },
  background: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    background: {
      type: ["fill"],
      displayName: ["Background"]
    },
    transparency: {
      type: ["numeric"],
      displayName: ["Transparency"],
      description: ["Set transparency for background color"]
    }
  },
  numericInputStyle: {
    fontColor: {
      type: ["fill"],
      displayName: ["Font color"],
      description: ["Font color of the cells"]
    },
    textSize: {
      type: ["numeric"],
      displayName: ["Text Size"]
    },
    fontFamily: {
      type: ["formatting"],
      displayName: ["Font family"]
    },
    background: {
      type: ["fill"],
      displayName: ["Background"]
    }
  },
  slider: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    },
    color: {
      type: ["fill"],
      displayName: ["Color"]
    }
  },
  dateRange: {
    includeToday: {
      type: ["bool"],
      displayName: ["Include today"]
    }
  },
  sentimentColors: {
    increaseFill: {
      type: ["fill"],
      displayName: ["Increase"]
    },
    decreaseFill: {
      type: ["fill"],
      displayName: ["Decrease"]
    },
    totalFill: {
      type: ["fill"],
      displayName: ["Total"]
    },
    otherFill: {
      type: ["fill"],
      displayName: ["Other"]
    }
  },
  breakdown: {
    maxBreakdowns: {
      type: ["integer"],
      displayName: ["Max breakdowns"],
      description: [
        "The number of individual breakdowns to show (rest grouped into Other)"
      ]
    }
  },
  indicator: {
    indicatorDisplayUnits: {
      type: ["formatting"],
      displayName: ["Display units"],
      description: ["Select the units (millions, billions, etc.)"]
    },
    indicatorPrecision: {
      type: ["numeric"],
      displayName: ["Value decimal places"],
      description: [
        "Select the number of decimal places to display for the values"
      ]
    },
    kpiFormat: {
      type: ["text"],
      displayName: ["Format"]
    }
  },
  trendline: {
    show: {
      type: ["bool"],
      displayName: ["Show"]
    }
  },
  goals: {
    showGoal: {
      type: ["bool"],
      displayName: ["Goal"]
    },
    showDistance: {
      type: ["bool"],
      displayName: ["Distance"]
    }
  },
  status: {
    direction: {
      type: ["enumeration"],
      displayName: ["Direction"]
    },
    goodColor: {
      type: ["fill"],
      displayName: ["Good Color"]
    },
    neutralColor: {
      type: ["fill"],
      displayName: ["Neutral Color"]
    },
    badColor: {
      type: ["fill"],
      displayName: ["Bad Color"]
    }
  }
};

const enumerations = {
  legend: {
    position: [
      {
        value: "Top",
        displayName: "Top"
      },
      {
        value: "Bottom",
        displayName: "Bottom"
      },
      {
        value: "Left",
        displayName: "Left"
      },
      {
        value: "Right",
        displayName: "Right"
      },
      {
        value: "TopCenter",
        displayName: "Top Center"
      },
      {
        value: "BottomCenter",
        displayName: "Bottom Center"
      },
      {
        value: "LeftCenter",
        displayName: "Left Center"
      },
      {
        value: "RightCenter",
        displayName: "Right center"
      }
    ],
    legendMarkerRendering: [
      {
        value: "markerOnly",
        displayName: "Markers only"
      },
      {
        value: "lineAndMarker",
        displayName: "Line and markers"
      },
      {
        value: "lineOnly",
        displayName: "Line only"
      }
    ],
    style: [
      {
        value: "MarkersOnly",
        displayName: "Markers only"
      },
      {
        value: "LineAndMarkers",
        displayName: "Line and markers"
      },
      {
        value: "LineOnly",
        displayName: "Line only"
      },
    ]
  },
  keyDrivers: {
    selectedNumericAnalysis: [{
      value: "Continuous",
      displayName: "Continuous"
    },
    {
      value: "Categorical",
      displayName: "Categorical"
    },],
    countType: [
      {
        value: "absolute",
        displayName: "Absolute"
      },
      {
        value: "relative",
        displayName: "Relative"
      }
    ]
  },
  categoryAxis: {
    axisScale: [
      {
        value: "Linear",
        displayName: "Linear"
      },
      {
        value: "log",
        displayName: "Log"
      }
    ],
    axisType: [
      {
        value: "Scalar",
        displayName: "Continuous"
      },
      {
        value: "Categorical",
        displayName: "Categorical"
      }
    ],
    axisStyle: [
      {
        value: "showTitleOnly",
        displayName: "Show title only"
      },
      {
        value: "showUnitOnly",
        displayName: "Show unit only"
      },
      {
        value: "showBoth",
        displayName: "Show both"
      }
    ],
    gridlineStyle: [
      {
        value: "dashed",
        displayName: "Dashed"
      },
      {
        value: "solid",
        displayName: "Solid"
      },
      {
        value: "dotted",
        displayName: "Dotted"
      }
    ],
    position: [
      {
        value: "Left",
        displayName: "Left"
      },
      {
        value: "Right",
        displayName: "Right"
      }
    ],
    style: [

    ]
  },
  shapes: {
    markerStyle: [
      {
        value: "circle",
        displayName: "●"
      },
      {
        value: "square",
        displayName: "■"
      },
      {
        value: "diamond",
        displayName: "◆"
      },
      {
        value: "triangle",
        displayName: "▲"
      },
      {
        value: "x",
        displayName: "☓"
      },
      {
        value: "shortDash",
        displayName: " -"
      },
      {
        value: "longDash",
        displayName: "—"
      },
      {
        value: "plus",
        displayName: "+"
      }
    ]
  },
  valueAxis: {
    position: [
      {
        value: "Left",
        displayName: "Left"
      },
      {
        value: "Right",
        displayName: "Right"
      }
    ],
    axisScale: [
      {
        value: "Linear",
        displayName: "Linear"
      },
      {
        value: "log",
        displayName: "Log"
      }
    ],
    axisStyle: [
      {
        value: "showTitleOnly",
        displayName: "Show title only"
      },
      {
        value: "showUnitOnly",
        displayName: "Show unit only"
      },
      {
        value: "showBoth",
        displayName: "Show both"
      }
    ],
    gridlineStyle: [
      {
        value: "dashed",
        displayName: "Dashed"
      },
      {
        value: "solid",
        displayName: "Solid"
      },
      {
        value: "dotted",
        displayName: "Dotted"
      }
    ],
    secPosition: [
      {
        value: "Left",
        displayName: "Left"
      },
      {
        value: "Right",
        displayName: "Right"
      }
    ],
    secAxisScale: [
      {
        value: "Linear",
        displayName: "Linear"
      },
      {
        value: "log",
        displayName: "Log"
      }
    ],
    secAxisStyle: [
      {
        value: "showTitleOnly",
        displayName: "Show title only"
      },
      {
        value: "showUnitOnly",
        displayName: "Show unit only"
      },
      {
        value: "showBoth",
        displayName: "Show both"
      }
    ],
    labelDisplayUnits: [
      {
        value: "Auto",
        displayName: "Auto"
      },
      {
        value: "0",
        displayName: "None"
      },
      {
        value: "thousands",
        displayName: "Thousands"
      },
      {
        value: "millions",
        displayName: "Millions"
      },
      {
        value: "billions",
        displayName: "Billions"
      },
      {
        value: "trillions",
        displayName: "Trillions"
      },
    ],
    labelPrecision: [

    ]
  },
  lineStyles: {
    strokeLineJoin: [
      {
        value: "miter",
        displayName: "Miter"
      },
      {
        value: "round",
        displayName: "Round"
      },
      {
        value: "bevel",
        displayName: "Bevel"
      }
    ],
    lineStyle: [
      {
        value: "dashed",
        displayName: "Dashed"
      },
      {
        value: "solid",
        displayName: "Solid"
      },
      {
        value: "dotted",
        displayName: "Dotted"
      }
    ],
    markerShape: [
      {
        value: "circle",
        displayName: "●"
      },
      {
        value: "square",
        displayName: "■"
      },
      {
        value: "diamond",
        displayName: "◆"
      },
      {
        value: "triangle",
        displayName: "▲"
      },
      {
        value: "x",
        displayName: "☓"
      },
      {
        value: "shortDash",
        displayName: " -"
      },
      {
        value: "longDash",
        displayName: "—"
      },
      {
        value: "plus",
        displayName: "+"
      }
    ]
  },
  layers: {
    layerTitle: [
      {
        value: 'Auto',
        displayName: 'Auto'
      }
    ],
    layerPosition: [
      {
        value: 'left',
        displayName: 'Left'
      },
      {
        value: 'right',
        displayName: 'Right'
      }
    ],


  },
  stylePreset: {
    name: [
      {
        "value": "Default",
        "displayName": "Default"
      },
      {
        "value": "None",
        "displayName": "None"
      },
      {
        "value": "Minimal",
        "displayName": "Minimal"
      },
      {
        "value": "Bold header",
        "displayName": "Bold header"
      },
      {
        "value": "Alternating rows",
        "displayName": "Alternating rows"
      },
      {
        "value": "Contrast alternating rows",
        "displayName": "Contrast alternating rows"
      },
      {
        "value": "Flashy rows",
        "displayName": "Flashy rows"
      },
      {
        "value": "Bold header flashy rows",
        "displayName": "Bold header flashy rows"
      },
      {
        "value": "Sparse",
        "displayName": "Sparse"
      },
      {
        "value": "Condensed",
        "displayName": "Condensed"
      }
    ],
  },
  pivotTable: {
    stylePreset: {
      name: [],
    },
    rowSubtotalsPosition: [
      {
        value: "Top",
        displayName: "Top"
      },
      {
        value: "Bottom",
        displayName: "Bottom"
      }
    ]
  },
  tableEx: {
    stylePreset: {
      name: [],
    },
    rowSubtotalsPosition: [
      {
        value: "Top",
        displayName: "Top"
      },
      {
        value: "Bottom",
        displayName: "Bottom"
      }
    ]
  },
  mapTools: {
    infographicsPosition: [
      {
        value: 'left',
        displayName: 'Left'
      },
      {
        value: 'right',
        displayName: 'Right'
      }
    ],
  },
  locationType: {
    country: countriFormatedList,
  },
  trend: {
    style: [
      {
        value: "dashed",
        displayName: "Dashed"
      },
      {
        value: "solid",
        displayName: "Solid"
      },
      {
        value: "dotted",
        displayName: "Dotted"
      }
    ]
  },
  gauge: {
    labelDisplayUnits: [
      {
        value: "dashed",
        displayName: "Dashed"
      },
    ]
  },
  y1AxisReferenceLine: {
    style: [
      {
        value: "dashed",
        displayName: "Dashed"
      },
      {
        value: "solid",
        displayName: "Solid"
      },
      {
        value: "dotted",
        displayName: "Dotted"
      }
    ],
    position: [
      {
        value: "back",
        displayName: "Behind"
      },
      {
        value: "front",
        displayName: "In Front"
      }
    ],
    dataLabelText: [
      {
        value: "Value",
        displayName: "Value"
      },
      {
        value: "Name",
        displayName: "Name"
      },
      {
        value: "ValueAndName",
        displayName: "Name and Value"
      }
    ],
    dataLabelHorizontalPosition: [
      {
        value: "left",
        displayName: "Left"
      },
      {
        value: "right",
        displayName: "Right"
      }
    ],
    dataLabelVerticalPosition: [
      {
        value: "above",
        displayName: "Above"
      },
      {
        value: "under",
        displayName: "Under"
      }
    ]
  },
  referenceLine: {
    style: [
      {
        value: "dashed",
        displayName: "Dashed"
      },
      {
        value: "solid",
        displayName: "Solid"
      },
      {
        value: "dotted",
        displayName: "Dotted"
      }
    ],
    position: [
      {
        value: "back",
        displayName: "Behind"
      },
      {
        value: "front",
        displayName: "In Front"
      }
    ],
    dataLabelText: [
      {
        value: "Value",
        displayName: "Value"
      },
      {
        value: "Name",
        displayName: "Name"
      },
      {
        value: "ValueAndName",
        displayName: "Name and Value"
      }
    ],
    dataLabelHorizontalPosition: [
      {
        value: "left",
        displayName: "Left"
      },
      {
        value: "right",
        displayName: "Right"
      }
    ],
    dataLabelVerticalPosition: [
      {
        value: "above",
        displayName: "Above"
      },
      {
        value: "under",
        displayName: "Under"
      }
    ]
  },
  indicator: {
    indicatorDisplayUnits: [
      {
        value: "Auto",
        displayName: "Auto"
      },
      {
        value: "0",
        displayName: "None"
      },
      {
        value: "thousands",
        displayName: "Thousands"
      },
      {
        value: "millions",
        displayName: "Millions"
      },
      {
        value: "billions",
        displayName: "Billions"
      },
      {
        value: "trillions",
        displayName: "Trillions"
      },
      // {
      //   value: "Auto",
      //   displayName: "Auto"
      // },
      // {
      //   value: "InsideEnd",
      //   displayName: "Inside End"
      // },
      // {
      //   value: "OutsideEnd",
      //   displayName: "Outside End"
      // },
      // {
      //   value: "InsideCenter",
      //   displayName: "Inside Center"
      // },
      // {
      //   value: "InsideBase",
      //   displayName: "Inside Base"
      // }
    ],
    horizontalAlignment: [
      {
        value: "Left",
        displayName: "Left"
      },
      {
        value: "Right",
        displayName: "Right"
      },

    ],
    verticalAlignment: [
      {
        value: "Top",
        displayName: "Top"
      },
      {
        value: "Bottom",
        displayName: "Bottom"
      },

    ],
  },
  visualTooltip: {
    type: [
      {
        value: "default",
        displayName: "Default"
      },
    ]
  },
  dropShadow: {
    position: [
      {
        value: "Inside",
        displayName: "Inside"
      },
      {
        value: "Outer",
        displayName: "Outer"
      },
    ],
    preset: [
      {
        value: "Top",
        displayName: "Top"
      },
      {
        value: "Bottom",
        displayName: "Bottom"
      },
      {
        value: "Left",
        displayName: "Left"
      },
      {
        value: "Right",
        displayName: "Right"
      },
      {
        value: "TopCenter",
        displayName: "Top Center"
      },
      {
        value: "TopRight",
        displayName: "Top Right"
      },
      {
        value: "TopLeft",
        displayName: "Top Left"
      },
      {
        value: "BottomCenter",
        displayName: "Bottom Center"
      },
      {
        value: "LeftCenter",
        displayName: "Left Center"
      },
      {
        value: "RightCenter",
        displayName: "Right center"
      }
    ],
  },
  shadow: {
    position: [
      {
        value: "Inside",
        displayName: "Inside"
      },
      {
        value: "Outer",
        displayName: "Outer"
      },
    ],
    shadowPositionPreset: [
      {
        value: "Top",
        displayName: "Top"
      },
      {
        value: "Bottom",
        displayName: "Bottom"
      },
      {
        value: "Left",
        displayName: "Left"
      },
      {
        value: "Right",
        displayName: "Right"
      },
      {
        value: "TopCenter",
        displayName: "Top Center"
      },
      {
        value: "TopRight",
        displayName: "Top Right"
      },
      {
        value: "TopLeft",
        displayName: "Top Left"
      },
      {
        value: "BottomCenter",
        displayName: "Bottom Center"
      },
      {
        value: "LeftCenter",
        displayName: "Left Center"
      },
      {
        value: "RightCenter",
        displayName: "Right center"
      }
    ],
  },
  labels: {
    labelOrientation: [
      {
        value: "vertical",
        displayName: "Vertical"
      },
      {
        value: "horizontal",
        displayName: "Horizontal"
      }
    ],
    labelPosition: [
      {
        value: "Auto",
        displayName: "Auto"
      },
      {
        value: "InsideEnd",
        displayName: "Inside End"
      },
      {
        value: "OutsideEnd",
        displayName: "Outside End"
      },
      {
        value: "InsideCenter",
        displayName: "Inside Center"
      },
      {
        value: "InsideBase",
        displayName: "Inside Base"
      }
    ],
    labelDensity: [
      {
        value: "default",
        displayName: "Default"
      },
      {
        value: "sparse",
        displayName: "Sparse"
      },
    ],
    labelStyle: [
      {
        value: "Category",
        displayName: "Category"
      },
      {
        value: "Data",
        displayName: "Data value"
      },
      {
        value: "Percent of total",
        displayName: "Percent of total"
      },
      {
        value: "Both",
        displayName: "Category, data value"
      },
      {
        value: "Category, percent of total",
        displayName: "Category, percent of total"
      },
      {
        value: "Data value, percent of total",
        displayName: "Data value, percent of total"
      },
      {
        value: "Category, data value, percent of total",
        displayName: "All detail labels"
      }
    ],
    labelDisplayUnits: [
      {
        value: "Auto",
        displayName: "Auto"
      },
      {
        value: "0",
        displayName: "None"
      },
      {
        value: "thousands",
        displayName: "Thousands"
      },
      {
        value: "millions",
        displayName: "Millions"
      },
      {
        value: "billions",
        displayName: "Billions"
      },
      {
        value: "trillions",
        displayName: "Trillions"
      },
    ]
  },
  target: {
    labelDisplayUnits: [
      {
        value: "Auto",
        displayName: "Auto"
      },
      {
        value: "0",
        displayName: "None"
      },
      {
        value: "thousands",
        displayName: "Thousands"
      },
      {
        value: "millions",
        displayName: "Millions"
      },
      {
        value: "billions",
        displayName: "Billions"
      },
      {
        value: "trillions",
        displayName: "Trillions"
      },
    ]
  },
  calloutValue: {
    labelDisplayUnits: [
      {
        value: "Auto",
        displayName: "Auto"
      },
      {
        value: "0",
        displayName: "None"
      },
      {
        value: "thousands",
        displayName: "Thousands"
      },
      {
        value: "millions",
        displayName: "Millions"
      },
      {
        value: "billions",
        displayName: "Billions"
      },
      {
        value: "trillions",
        displayName: "Trillions"
      },
    ]
  },
  card: {
    outline: [
      {
        value: "None",
        displayName: "None"
      },
      {
        value: "BottomOnly",
        displayName: "Bottom only"
      },
      {
        value: "TopOnly",
        displayName: "Top only"
      },
      {
        value: "LeftOnly",
        displayName: "Left only"
      },
      {
        value: "RightOnly",
        displayName: "Right only"
      },
      {
        value: "TopBottom",
        displayName: "Top + bottom"
      },
      {
        value: "LeftRight",
        displayName: "Left + right"
      },
      {
        value: "Frame",
        displayName: "Frame"
      }
    ]
  },
  imageScaling: {
    imageScalingType: [
      {
        value: "Normal",
        displayName: "Normal"
      },
      {
        value: "Fit",
        displayName: "Fit"
      },
      {
        value: "Fill",
        displayName: "Fill"
      }
    ]
  },
  forecast: {
    confidenceBandStyle: [
      {
        value: "fill",
        displayName: "Fill"
      },
      {
        value: "line",
        displayName: "Line"
      },
      {
        value: "none",
        displayName: "None"
      }
    ],
    style: [
      {
        value: "dashed",
        displayName: "Dashed"
      },
      {
        value: "solid",
        displayName: "Solid"
      },
      {
        value: "dotted",
        displayName: "Dotted"
      }
    ]
  },
  mapStyles: {
    mapTheme: [
      {
        value: "aerial",
        displayName: "Aerial"
      },
      {
        value: "canvasDark",
        displayName: "Dark"
      },
      {
        value: "canvasLight",
        displayName: "Light"
      },
      {
        value: "grayscale",
        displayName: "Grayscale"
      },
      {
        value: "road",
        displayName: "Road"
      }
    ]
  },
  shape: {
    projectionEnum: [
      {
        value: "albersUsa",
        displayName: "Albers USA"
      },
      {
        value: "equirectangular",
        displayName: "Equirectangular"
      },
      {
        value: "mercator",
        displayName: "Mercator"
      },
      {
        value: "orthographic",
        displayName: "Orthographic"
      }
    ],
    tileShape:
      [
        {
          "value": "Arrow",
          "displayName": "Arrow"
        },
        {
          "value": "ArrowChevron",
          "displayName": "Arrow: Chevron"
        },
        {
          "value": "Arrow: Pentagon",
          "displayName": "Arrow: Pentagon"
        },
        {
          "value": "Heart",
          "displayName": "Heart"
        },
        {
          "value": "Hexagon",
          "displayName": "Hexagon"
        },
        {
          "value": "Line",
          "displayName": "Line"
        },
        {
          "value": "Octagon",
          "displayName": "Octagon"
        },
        {
          "value": "Oval",
          "displayName": "Oval"
        },
        {
          "value": "Parallelogram",
          "displayName": "Parallelogram"
        },
        {
          "value": "Pentagon",
          "displayName": "Pentagon"
        },
        {
          "value": "Pill",
          "displayName": "Pill"
        },
        {
          "value": "Rectangle",
          "displayName": "Rectangle"
        },
        {
          "value": "RoundedRectangle",
          "displayName": "Rounded Rectangle"
        },
        {
          "value": "TabSingleCornerSnipped",
          "displayName": "Tab: Single Corner Snipped"
        },
        {
          "value": "TabTopCornersSnipped",
          "displayName": "Tab: Top Corners Snipped"
        },
        {
          "value": "TabSingleCornerRounded",
          "displayName": "Tab: Single Corner Rounded"
        },
        {
          "value": "TabTopCornersRounded",
          "displayName": "Tab: Top Corners Rounded"
        },
        {
          "value": "SpeechBubble",
          "displayName": "Speech Bubble"
        },
        {
          "value": "Trapezoid",
          "displayName": "Trapezoid"
        },
        {
          "value": "IsoscelesTriangle",
          "displayName": "Isosceles Triangle"
        },
        {
          "value": "RightTriangle",
          "displayName": "Right Triangle"
        }
      ],
    linecapType: [
      {
        "value": "flat",
        "displayName": "Flat"
      }
    ]

  },
  xAxisReferenceLine: {
    style: [
      {
        value: "dashed",
        displayName: "Dashed"
      },
      {
        value: "solid",
        displayName: "Solid"
      },
      {
        value: "dotted",
        displayName: "Dotted"
      }
    ],
    position: [
      {
        value: "back",
        displayName: "Behind"
      },
      {
        value: "front",
        displayName: "In Front"
      }
    ],
    dataLabelText: [
      {
        value: "Value",
        displayName: "Value"
      },
      {
        value: "Name",
        displayName: "Name"
      },
      {
        value: "ValueAndName",
        displayName: "Name and Value"
      }
    ],
    dataLabelHorizontalPosition: [
      {
        value: "left",
        displayName: "Left"
      },
      {
        value: "right",
        displayName: "Right"
      }
    ],
    dataLabelVerticalPosition: [
      {
        value: "above",
        displayName: "Above"
      },
      {
        value: "under",
        displayName: "Under"
      }
    ]
  },
  ratioLine: {
    style: [
      {
        value: "dashed",
        displayName: "Dashed"
      },
      {
        value: "solid",
        displayName: "Solid"
      },
      {
        value: "dotted",
        displayName: "Dotted"
      }
    ]
  },
  columnHeaders: {
    outline: [
      {
        value: "None",
        displayName: "None"
      },
      {
        value: "BottomOnly",
        displayName: "Bottom only"
      },
      {
        value: "TopOnly",
        displayName: "Top only"
      },
      {
        value: "LeftOnly",
        displayName: "Left only"
      },
      {
        value: "RightOnly",
        displayName: "Right only"
      },
      {
        value: "TopBottom",
        displayName: "Top + bottom"
      },
      {
        value: "LeftRight",
        displayName: "Left + right"
      },
      {
        value: "Frame",
        displayName: "Frame"
      }
    ]
  },
  values: {
    outline: [
      {
        value: "None",
        displayName: "None"
      },
      {
        value: "BottomOnly",
        displayName: "Bottom only"
      },
      {
        value: "TopOnly",
        displayName: "Top only"
      },
      {
        value: "LeftOnly",
        displayName: "Left only"
      },
      {
        value: "RightOnly",
        displayName: "Right only"
      },
      {
        value: "TopBottom",
        displayName: "Top + bottom"
      },
      {
        value: "LeftRight",
        displayName: "Left + right"
      },
      {
        value: "Frame",
        displayName: "Frame"
      }
    ]
  },
  total: {
    outline: [
      {
        value: "None",
        displayName: "None"
      },
      {
        value: "BottomOnly",
        displayName: "Bottom only"
      },
      {
        value: "TopOnly",
        displayName: "Top only"
      },
      {
        value: "LeftOnly",
        displayName: "Left only"
      },
      {
        value: "RightOnly",
        displayName: "Right only"
      },
      {
        value: "TopBottom",
        displayName: "Top + bottom"
      },
      {
        value: "LeftRight",
        displayName: "Left + right"
      },
      {
        value: "Frame",
        displayName: "Frame"
      }
    ]
  },
  rowHeaders: {
    outline: [
      {
        value: "None",
        displayName: "None"
      },
      {
        value: "BottomOnly",
        displayName: "Bottom only"
      },
      {
        value: "TopOnly",
        displayName: "Top only"
      },
      {
        value: "LeftOnly",
        displayName: "Left only"
      },
      {
        value: "RightOnly",
        displayName: "Right only"
      },
      {
        value: "TopBottom",
        displayName: "Top + bottom"
      },
      {
        value: "LeftRight",
        displayName: "Left + right"
      },
      {
        value: "Frame",
        displayName: "Frame"
      }
    ]
  },
  goals: {
    distanceLabel: [
      {
        "value": "Value",
        "displayName": "Value"
      },
      {
        "value": "Percent",
        "displayName": "Percent"
      },
      {
        "value": "Value, percent",
        "displayName": "Value, percent"
      }
    ]
  },
  subTotals: {
    outline: [
      {
        value: "None",
        displayName: "None"
      },
      {
        value: "BottomOnly",
        displayName: "Bottom only"
      },
      {
        value: "TopOnly",
        displayName: "Top only"
      },
      {
        value: "LeftOnly",
        displayName: "Left only"
      },
      {
        value: "RightOnly",
        displayName: "Right only"
      },
      {
        value: "TopBottom",
        displayName: "Top + bottom"
      },
      {
        value: "LeftRight",
        displayName: "Left + right"
      },
      {
        value: "Frame",
        displayName: "Frame"
      }
    ],
    rowSubtotalsPosition: [
      {
        value: "Top",
        displayName: "Top"
      },
      {
        value: "Bottom",
        displayName: "Bottom"
      }
    ]
  },
  general: {
    orientation: [
      {
        value: "vertical",
        displayName: "Vertical"
      },
      {
        value: "horizontal",
        displayName: "Horizontal"
      }
    ]
  },
  data: {
    relativeRange: [
      {
        value: "Last",
        displayName: "Last"
      },
      {
        value: "Next",
        displayName: "Next"
      },
      {
        value: "This",
        displayName: "This"
      }
    ],
    relativePeriod: [
      {
        value: "None",
        displayName: "Select"
      },
      {
        value: "Days",
        displayName: "Days"
      },
      {
        value: "Weeks",
        displayName: "Weeks"
      },
      {
        value: "Calendar Weeks",
        displayName: "Weeks (Calendar)"
      },
      {
        value: "Months",
        displayName: "Months"
      },
      {
        value: "Calendar Months",
        displayName: "Months (Calendar)"
      },
      {
        value: "Years",
        displayName: "Years"
      },
      {
        value: "Calendar Years",
        displayName: "Years (Calendar)"
      }
    ],
    mode: [
      {
        value: "Between",
        displayName: "Between"
      },
      {
        value: "Before",
        displayName: "Before"
      },
      {
        value: "After",
        displayName: "After"
      },
      {
        value: "Basic",
        displayName: "List"
      },
      {
        value: "Dropdown",
        displayName: "Dropdown"
      },
      {
        value: "Relative",
        displayName: "Relative"
      },
      {
        value: "Single",
        displayName: "Single Value"
      }
    ]
  },
  dataBars: {
    dataBarScalingType: [
      {
        value: "topNode",
        displayName: "Top node"
      },
      {
        value: "parentNode",
        displayName: "Parent node"
      },
      {
        value: "levelMaximum",
        displayName: "Level maximum"
      },
    ]
  },
  tree: {
    connectorType: [
      {
        value: "miter",
        displayName: "Miter"
      },
      {
        value: "round",
        displayName: "Round"
      },
      {
        value: "bevel",
        displayName: "Bevel"
      }
    ],
    density: [
      {
        value: "default",
        displayName: "Default"
      },
      {
        value: "sparse",
        displayName: "Sparse"
      },

    ],
  },
  analysis: {
    aiMode: [
      {
        value: "absolute",
        displayName: "Absolute"
      },
      {
        value: "relative",
        displayName: "Relative"
      }
      // {
      //   value: "Between",
      //   displayName: "Between"
      // },
      // {
      //   value: "Before",
      //   displayName: "Before"
      // },
      // {
      //   value: "After",
      //   displayName: "After"
      // },
      // {
      //   value: "Basic",
      //   displayName: "List"
      // },
      // {
      //   value: "Dropdown",
      //   displayName: "Dropdown"
      // },
      // {
      //   value: "Relative",
      //   displayName: "Relative"
      // },
      // {
      //   value: "Single",
      //   displayName: "Single Value"
      // }
    ],
  },
  dataLabels: {
    dataLabelDisplayUnits: [
      {
        value: "Auto",
        displayName: "Auto"
      },
      {
        value: "0",
        displayName: "None"
      },
      {
        value: "thousands",
        displayName: "Thousands"
      },
      {
        value: "millions",
        displayName: "Millions"
      },
      {
        value: "billions",
        displayName: "Billions"
      },
      {
        value: "trillions",
        displayName: "Trillions"
      },
    ],

  },
  header: {
    outline: [
      {
        value: "None",
        displayName: "None"
      },
      {
        value: "BottomOnly",
        displayName: "Bottom only"
      },
      {
        value: "TopOnly",
        displayName: "Top only"
      },
      {
        value: "LeftOnly",
        displayName: "Left only"
      },
      {
        value: "RightOnly",
        displayName: "Right only"
      },
      {
        value: "TopBottom",
        displayName: "Top + bottom"
      },
      {
        value: "LeftRight",
        displayName: "Left + right"
      },
      {
        value: "Frame",
        displayName: "Frame"
      }
    ]
  },
  items: {
    outline: [
      {
        value: "None",
        displayName: "None"
      },
      {
        value: "BottomOnly",
        displayName: "Bottom only"
      },
      {
        value: "TopOnly",
        displayName: "Top only"
      },
      {
        value: "LeftOnly",
        displayName: "Left only"
      },
      {
        value: "RightOnly",
        displayName: "Right only"
      },
      {
        value: "TopBottom",
        displayName: "Top + bottom"
      },
      {
        value: "LeftRight",
        displayName: "Left + right"
      },
      {
        value: "Frame",
        displayName: "Frame"
      }
    ]
  },
  status: {
    direction: [
      {
        value: "Positive",
        displayName: "High is good"
      },
      {
        value: "Negative",
        displayName: "Low is good"
      }
    ]
  }
};

export { cardName, visualStyles, items, enumerations };
